var config = { 
  howManyToShow: 10,
  howManyToStoreInMemory: 10, 
  wrapperId: 'recently-viewed-products', 
  templateId: 'recently-viewed-product-template',
  onComplete: null
};

var productHandleQueue = [];
var wrapper = null;
var template = null;
var shown = 0;

var cookie = {
  configuration: {
    expires: 90,
    path: '/',
    domain: window.location.hostname
  },
  name: 'shopify_recently_viewed',
  write: function(recentlyViewed) {
    jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
  },
  read: function() {
    var recentlyViewed = [];
    var cookieValue = jQuery.cookie(this.name);
    if (cookieValue !== null) {
      recentlyViewed = cookieValue.split(' ');
    }
    return recentlyViewed;        
  },
  destroy: function() {
    jQuery.cookie(this.name, null, this.configuration);
  },
  remove: function(productHandle) {
    var recentlyViewed = this.read();
    var position = jQuery.inArray(productHandle, recentlyViewed);
    if (position !== -1) {
      recentlyViewed.splice(position, 1);
      this.write(recentlyViewed);
    }       
  }
};

var recentlyViewed = cookie.read();
var productHandle = window.productHandle;
if (typeof productHandle != 'undefined') {
  var position = jQuery.inArray(productHandle, recentlyViewed);
  if (position === -1) {
    recentlyViewed.unshift(productHandle);
    recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
  }
  else {
    recentlyViewed.splice(position, 1);
    recentlyViewed.unshift(productHandle);              
  }
}
cookie.write(recentlyViewed);
productHandleQueue = cookie.read();